import React from "react";
import "./OurStory.css";
import venueImg from "../../Images/Venue_image.png"; // replace with your image

import { FaCar, FaWifi, FaUtensils, FaMusic, FaWind, FaBolt, FaStar } from "react-icons/fa";

export default function OurStory() {
  return (
    <section className="ourstory-section">
      <div className="container">

        {/* Top Title */}
        <div className="section-header">
          <span className="line"></span>
          <p>Our Story</p>
          <span className="line"></span>
        </div>

        <div className="ourstory-content">

          {/* Left Image */}
          <div className="image-wrapper">
            <img src={venueImg} alt="Venue" />
            <div className="experience-box">
              <h2>7+</h2>
              <p>Years Of<br />experience</p>
            </div>
          </div>

          {/* Right Content */}
          <div className="text-content">
            <h2>
              A Venue Built <br />
              for Unforgettable <span>Moments</span>
            </h2>

            <p>
              Nestled in the heart of the city, Luxe Venue offers a sophisticated blend
              of modern luxury and timeless elegance. With a capacity to host up to
              500 guests, our banquet hall is designed to provide a seamless
              experience for your special occasions.
              <br /><br />
              From intimate gatherings to grand celebrations, our dedicated team
              ensures every detail is meticulously planned and executed.
            </p>

            {/* Features */}
            <div className="features">
              <div className="feature-item"><FaCar size={50} color="red" /> <span>Parking</span></div>
              <div className="feature-item"><FaWifi size={50} color="red" /> <span>Internet</span></div>
              <div className="feature-item"><FaUtensils size={50} color="red" /> <span>Catering</span></div>
              <div className="feature-item"><FaMusic size={50} color="red" /> <span>DJ/Sound</span></div>
              <div className="feature-item"><FaWind size={50} color="red" /> <span>Air Conditioner</span></div>
              <div className="feature-item"><FaBolt size={50} color="red" /> <span>Power Backup</span></div>
              <div className="feature-item"><FaStar size={50} color="red" /> <span>Premium decor</span></div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}